import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { FetchPolicy } from 'utils/enum/Core';
import ModalUtils from 'utils/ModalUtils';
import StringUtils from 'lib/StringUtils';
import CompanyQuery from 'services/graphQL/query/setting/CompanyQuery';
import UserSettingQuery from 'services/graphQL/query/setting/UserSettingQuery';

const useGlobalRole = (
    category,
    key,
) => {
    const [state, setState] = useState({
        records: [],
        selectedTypes: [],
        loaded: false,
    });

    const {
        loaded,
        records,
        selectedTypes,
    } = state;

    const {
        data: employeeData, error: employeeError, loading: employeeLoading,
    } = useQuery(UserSettingQuery.GET_EMPLOYEE_TYPES, {
        fetchPolicy: FetchPolicy.NETWORK_ONLY,
    });

    const {
        data: includedData, error: includedError, loading: includedLoading,
    } = useQuery(CompanyQuery.GET_COMPANY_SETTINGS, {
        variables: {
            category,
            key: [key],
        },
        fetchPolicy: FetchPolicy.NETWORK_ONLY,
    });

    useEffect(() => {
        if (employeeError) {
            ModalUtils.errorMessage(null, employeeError?.message);
            return;
        }

        if (!employeeLoading && employeeData) {
            setState((prevState) => ({
                ...prevState,
                records: employeeData.getEmployeeTypes,
            }));
        }
    }, [employeeData, employeeError, employeeLoading]);

    useEffect(() => {
        if (includedError) {
            ModalUtils.errorMessage(null, includedError?.message);
            return;
        }

        if (!includedLoading && includedData) {
            const data = includedData.getCompanySettings ?? [];
            if (data.length > 0) {
                const ids = data[0].value ?? '';
                if (!StringUtils.isEmpty(ids)) {
                    setState((prevState) => ({
                        ...prevState,
                        selectedTypes: ids.split(',').map((id) => Number(id.trim())),
                    }));

                    return;
                }
            }

            setState((prevState) => ({
                ...prevState,
                selectedTypes: [],
            }));
        }
    }, [includedData, includedError, includedLoading]);

    useEffect(() => {
        if (!employeeLoading && !includedLoading) {
            setState((prevState) => ({
                ...prevState,
                loaded: true,
            }));
        }
    }, [employeeLoading, includedLoading]);

    return {
        loaded,
        employeeTypes: records.filter((r) => selectedTypes.includes(r.employeeTypeId)).map((r) => r.employeeType),
    };
};

export default useGlobalRole;
